import React from 'react';

import AdminDiscoveredChannelsPage from '../../screens/AdminDiscoveredChannelsPage/AdminDiscoveredChannelsPage.component';

const AdminDiscoveredChannels: React.FC = () => <AdminDiscoveredChannelsPage />;

export default AdminDiscoveredChannels;
